import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../../core/layout/Card';
import Separator from '../../../../core/layout/Separator';
import ItemHistoryListContainer from '../ItemHistoryListContainer';
import UnitItemHistoryBreadcrumbs from './UnitItemHistoryBreadcrumbs';
import UnitItemHistoryDetail from './UnitItemHistoryDetail';

const UnitItemHistoryScene = (props) => (
  <div>
    <UnitItemHistoryBreadcrumbs unitItem={props.unitItem} fetching={props.fetching} />
    <Separator />
    <UnitItemHistoryDetail unitItem={props.unitItem} fetching={props.fetching} />
    <Card title="History" loading={props.fetching}>
      <ItemHistoryListContainer itemId={props.unitItem.item.id} />
    </Card>
  </div>
);

UnitItemHistoryScene.propTypes = {
  unitItem: PropTypes.shape({
    order: PropTypes.number.isRequired,
    group: PropTypes.number.isRequired,
    unit: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      module: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        course: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
    item: PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      type: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  fetching: PropTypes.bool,
};

UnitItemHistoryScene.defaultProps = {
  fetching: false,
};

export default UnitItemHistoryScene;
